(() => {
  if (!window.location.pathname.includes('/products/natural-massage-oil')) return;
  const imageUrl = 'https://cdn.shopify.com/s/files/1/1021/7314/7462/files/aureko-natural-massage-oil-hero.png?v=1788730435';
  const ensureOilImage = () => {
    const media = document.querySelector('.aop-media');
    if (!media) return;
    let image = media.querySelector('img');
    if (!image) {
      image = document.createElement('img');
      image.alt = 'AUREKO Natural Massage Oil bottle in a premium warm body-care setting';
      image.loading = 'eager';
      image.decoding = 'async';
      media.prepend(image);
    }
    if (!image.src || !image.src.includes('aureko-natural-massage-oil-hero.png')) image.src = imageUrl;
    image.addEventListener('error', () => {
      if (image.src !== imageUrl) image.src = imageUrl;
    }, { once: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ensureOilImage, { once: true });
  else ensureOilImage();
})();
